import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {AutocompleteComponent} from "../autocomplete/autocomplete.component";
import {debounceTime, filter, switchMap, tap} from "rxjs/operators";

export class Adapter<T> {
  dataProvider : (string) => Observable<T[]>;
  mapper: (T) => string;
  detailsMapper: (T) => string;
}

@Component({
    selector: 'app-person-autocomplete',
    templateUrl: './person-autocomplete.component.html',
    styleUrls: ['./person-autocomplete.component.scss'],
    standalone: false
})
export class PersonAutocompleteComponent<T> implements OnInit {
  private mAdapter: Adapter<T>;
  data: T[];
  private termSubject = new Subject<string>();
  @ViewChildren("autocompleteItem")
  itemViews: QueryList<ElementRef>;

  constructor() {
    this.termSubject.pipe(
      filter( term => term.length > 0),
      debounceTime(300),
      switchMap( term => this.mAdapter.dataProvider(term)),
      tap<T[]>( data => {
        this.data = data;
        this.autocomplete.clearFocus();
      })
    ).subscribe()
  }

  @ViewChild("autocompleteComponent")
  autocomplete: AutocompleteComponent<T>
  mCurrentActive: T;

  set currentActive(el: T) {
    this.mCurrentActive = el;
    this.focusActive();
  }

  get currentActive(){
    return this.mCurrentActive;
  }

  @Input()
  set adapter(adapter: Adapter<T>) {
    this.mAdapter = adapter;
  }

  @Output()
  itemSelected = new EventEmitter<T>();

  ngOnInit(): void {
  }

  focusActive() {
    if (!this.currentActive) return;
    const selectedItemIndex = this.data.indexOf(this.currentActive);
    if (selectedItemIndex < 0) return;
    const itemView = this.itemViews.filter( (i, index) => index == selectedItemIndex );
    if (!itemView || itemView.length === 0) return;
    itemView[0].nativeElement.scrollIntoView({
      behavior : "smooth",
      block : "nearest"
    });
  }

  onTermUpdate(currentTerm: string) {
    this.termSubject.next(currentTerm);
  }

  getItemDescription(item: T) {
    return this.mAdapter.mapper(item);
  }

  onItemSelected(selected: T) {
    this.itemSelected.emit(selected);
  }

  getMail(item: T) {
      return this.mAdapter.detailsMapper(item);
  }
}
